import User from "../models/User"
import AccountTechRates from "./AccountTechRates";
import AccountTechPaymentTypes from "./AccountTechPaymentTypes";
import AccountTechDetails from "./AccountTechDetails";

type Props = {
    userId?: string
    model?: User
    onUpdate?: (user: User) => void
}

export default function AccountTechSettings(props: Props) {

    return (
        <>
            <AccountTechRates userId={props.userId} model={props.model} onUpdate={props.onUpdate} />
            <AccountTechDetails userId={props.userId} model={props.model} onUpdate={props.onUpdate} />
            <AccountTechPaymentTypes userId={props.userId} model={props.model} onUpdate={props.onUpdate} />
        </>
    )
}
